import script from "./ToastLink.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastLink.vue?vue&type=script&setup=true&lang=js"

import "./ToastLink.vue?vue&type=style&index=0&id=3ce25b6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce25b6a"]])

export default __exports__